import React from 'react';
import PropTypes from 'prop-types';

import {
    Button, ButtonGroup, Flex, Heading, Image, ModalDialog, Paragraph, Spacer, TextButton,
} from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import LimitedMobility from 'app/shared/images/LimitedMobility.svg';

const propTypes = {
    close: PropTypes.func.isRequired,
};
const defaultProps = {};

const ExitRentGuaranteeModal = ({ close, history, ...rest }) => {
    const handleExitRentGuarantee = () => {
        history.goBack();
    };
    return (
        <ModalDialog
            {...rest}
            wide={true}
            header={
                <Heading level={6}>Exit Rent Guarantee setup</Heading>
            }
            body={(
                <>
                    <Flex display="flex" alignItems="center" flexDirection="column" marginBottom="xs">
                        <Spacer marginY="md">
                            <Image src={LimitedMobility} alt="" />
                        </Spacer>
                        <Heading level={6}>Are you sure?</Heading>
                    </Flex>
                    <Row>
                        <Col xs={2} />
                        <Col xs={8}>
                            <Paragraph marginBottom="sm">
                                We will undo any selections you have made to set up Rent Guarantee. If you change your
                                mind, you can always opt in before you sign a tenant.
                            </Paragraph>
                            <Paragraph>
                                You will not lose any of the information you filled out for your property and can
                                continue to list your property.
                            </Paragraph>
                        </Col>
                        <Col xs={2} />
                    </Row>
                </>
            )}
            footer={(
                <ButtonGroup aria-label="exit choices">
                    <TextButton
                        buttonType="primary"
                        onClick={close}
                    >
                        No, continue
                    </TextButton>
                    <Button
                        buttonType="primary"
                        onClick={handleExitRentGuarantee}
                    >
                        Yes, exit now
                    </Button>
                </ButtonGroup>
            )}
        />
    );
};

ExitRentGuaranteeModal.propTypes = propTypes;
ExitRentGuaranteeModal.defaultProps = defaultProps;

export default ExitRentGuaranteeModal;
